<ng-container>
  <a href=""><i [inlineSVG]="'../../../../../ntx-app/assets/images/logo.svg'" class="logo"></i></a>
  <app-breadcrumbs *ngIf="user"></app-breadcrumbs>
  <div class="d-flex align-items-center gap-3 actions-container">
    <app-global-search></app-global-search>
    <nb-actions size="medium">
      <nb-action class="user-action" *ngIf="user">
        <nb-user [nbContextMenu]="userMenu"
                 [nbContextMenuTag]="'user-menu'"
                 [lyPicture]="'true'"
                 [name]="user?.firstName + ' ' + user?.surname"
                 [showName]="false"
                 [picture]="user?.picture">
        </nb-user>
      </nb-action>
    </nb-actions>
  </div>
</ng-container>
